import { render, staticRenderFns } from "./addCampaign.vue?vue&type=template&id=7436647f&lang=pug"
import script from "./addCampaign.vue?vue&type=script&lang=js"
export * from "./addCampaign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports